var butts = document.querySelectorAll('button[data-confirm]');
butts.forEach((butt: HTMLButtonElement) => {
    butt.addEventListener('click', (e) => {

        if (butt.dataset.confirm === "true") {
            delete butt.dataset.confirm;
            return;
        }

        e.preventDefault();
        e.stopPropagation();

        swalModal.fire({
            title: (Bookhus as any).Localization.Standard.UI.GeneralText.AreYouSure,
            confirmButtonText: (Bookhus as any).Localization.Standard.UI.ButtonText.Confirm,            
            cancelButtonText: (Bookhus as any).Localization.Standard.UI.ButtonText.Cancel,
            showCancelButton: true
        }).then((result) => {
            if (!result.isConfirmed) {
                return;
            }

            butt.dataset.confirm = "true";
            butt.click();
        });
    });
});